import React from 'react';
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';

import * as Icon from 'react-feather';

import { connect } from 'react-redux';
import {
  logoutMS,
  logoutWithJWT,
} from '../../../redux/actions/auth/loginActions';
import { setProfile } from '../../../redux/actions/profile/profile';
import { getProfile } from '../../../actions/profile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tracker from '@openreplay/tracker';


const tracker = new Tracker({
  projectKey: 'nlFarrINhVQE9e6aueuO',
  ingestPoint: 'https://openreplay.boltinsight.com/ingest',
  collectHttpHeaders: false,
  collectWebSockets: true,
  collectConsole: true,
  collectError: true,
  collectFrames: true,
  collectPerformance: true,
  collectMedia: true,
  collectNetwork: true,
  network: {
    request: true,
    response: true,
  },
  maskAllInputs: true,
  maskAllTextNodes: true,
  maskAllSelectors: true,
  maskInputValue: true,
  maskTextContent: true,
  maskPlaceholder: true,
});
tracker.start();

const UserDropdown = (props) => {
  return (
    <DropdownMenu right>
      <DropdownItem
        tag="a"
        href="/managers"
      >
        <FontAwesomeIcon size={14} className="mr-50" icon="user-plus" />
        <span className="align-middle">Manage Users</span>
      </DropdownItem>
      <DropdownItem
        tag="a"
        href="#"
        onClick={() => logoutMS().then(props.logoutWithJWT())}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: [],
  };

  componentDidMount() {
    // axios.get("/api/main-search/data").then(({ data }) => {
    //   this.setState({ suggestions: data.searchResult });
    // });
    getProfile().then((response) => {
      const { fname, lname, email, role, titles = [] } = response.data.admin;
      this.props.setProfile({ name: `${fname} ${lname}`, email, role, titles });
      tracker.setUserID(email);
    }).catch((error) => {
      console.error('getProfile error:', error);
    });
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch,
    });
  };

  render() {
    const { name, role } = this.props.profile || {};
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600 m-auto">
                {name || ''}
              </span>
            </div>
            <span data-tour="user">
              <img
                src={this.props.userImg}
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    );
  }
}
export default connect((state) => ({ profile: state.profile }), {
  logoutWithJWT,
  setProfile,
})(NavbarUser);
